<template>
  <div class="modal shadow" role="dialog" tabindex="-1" id="deleteDeviceModal">
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete Device</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <h4>Confirm DELETE</h4>
          <p>
            Are you sure you want to delete <strong>{{ deviceName }}</strong
            >, this action is irreversible.
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" type="button" data-dismiss="modal">
            CANCEL
          </button>

          <button
            class="btn btn-sm btn-danger"
            type="button"
            data-dismiss="modal"
            @click="deleteDevice"
          >
            DELETE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "deleteDeviceModal",
  props: ["deviceName", "deviceId", "hostId"],
  data: () => ({}),
  computed: {},
  methods: {
    deleteDevice() {
      this.$store.dispatch("deleteDevice", this.deviceId);
      this.$store.dispatch("fetchCurrentHost", {
        host_id: this.host_id,
      });
      this.$router.push({
        name: "host_detail",
        params: {
          host_id: this.hostId,
        },
      });
    },
  },
};
</script>
